"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var CardWithinContext_1 = require("./CardWithinContext");
/**
 * The `Card` is a container component which may have
 * an optional label and will be displayed as an UI card.
 * [CardWithinContext](#!/CardWithinContext) component.
 */
exports.Card = withContext_1.withErgoElementsContext('Card', CardWithinContext_1.CardWithinContext);
exports.default = exports.Card;
__export(require("./CardWithinContext"));
//# sourceMappingURL=Card.js.map